import kaplay from "kaplay";
import { DEBUG } from "../assets";
import { COLORS, DEFAULT_LAYER, LAYERS } from "../config/constants";
import { BUTTONS } from "../config/controls";

export const k = kaplay({
    global: false,
    root: document.querySelector<HTMLElement>("#game")!,
    background: COLORS.meadow,
    pixelDensity: Math.min(window.devicePixelRatio, 2),
    texFilter: "linear",
    debug: DEBUG,
    debugKey: "f1",
    buttons: BUTTONS,
});

k.setLayers(LAYERS, DEFAULT_LAYER);
